/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null
};

const userIdSlice = createSlice({
  name: "userId",
  initialState,
  reducers: {
    setCurrentUserId(state, action) {
      state.userId = action.payload;
    }
  }
});

export const { setCurrentUserId } = userIdSlice.actions;
export default userIdSlice.reducer;
